import { createApp } from "vue";
import {
    createPinia,
    setActivePinia
} from "pinia";

import App from "./App.vue";
import { router } from "./router";

import store from "@/store";
import storeConsts from "@/store/consts";
import authConsts from "@/store/modules/auth/consts";

import {
    setSessionExpiredHandler
} from "@/api/http";

import "leaflet/dist/leaflet.css";

const app = createApp(App);

const pinia = createPinia();

setActivePinia(pinia);

app.use(store);
app.use(pinia);

router.beforeEach(async to => {
    if (!to.meta.requiresAuth) {
        return true;
    }

    if (!store.state[storeConsts.APP_INITIALIZED]) {
        await store.dispatch(
            storeConsts.INIT_APP
        );
    }

    const currentUser =
        store.state[authConsts.STORE_PATH][
            authConsts.CURRENT_USER
            ];

    if (!currentUser) {
        return {
            name: "Authentication",
            query: {
                redirect: to.fullPath,
            },
        };
    }

    const allowedRoles = to.meta.roles;

    if (
        allowedRoles &&
        !allowedRoles.includes(currentUser.role)
    ) {
        return currentUser.role === "admin"
            ? { name: "Administration" }
            : { name: "Company" };
    }

    return true;
});

app.use(router);

setSessionExpiredHandler(() => {
    store.commit(
        `${authConsts.STORE_PATH}/${authConsts.CURRENT_USER}`,
        null
    );

    const currentRoute =
        router.currentRoute.value;

    if (currentRoute.meta.requiresAuth) {
        router.replace({
            name: "Authentication",
            query: {
                redirect: currentRoute.fullPath,
            },
        });
    }
});

app.mount("#app");